<ng-container *transloco="let t">
  <app-page-template>
  <section class="upper-section-background">
    <div class="container">
      <div class="px-2 px-md-5 py-4 py-md-5">
        <app-form-card>
          <h1 class="text-uppercase pb-4">{{t('footer.privacy.policy')}}</h1>
          <h3 class="text-uppercase">
            {{t('privacy.policy.details')}}
          </h3>
          <p class="fw-bold pb-3 pt-4">
            {{t('privacy.policy.general.conditions')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.general.conditions.1')}}
          </p>
          <p class="pb-3">

            {{t('privacy.policy.general.conditions.2.1')}}
            <a target="_blank" href="https://www.stotinka.hr"> www.stotinka.hr</a>
            {{t('privacy.policy.general.conditions.2.2')}}
          </p>
          <p>

            {{t('privacy.policy.general.conditions.3')}}
          </p>
          <p class="fw-bold pb-3 pt-4">
            {{t('privacy.policy.personal.data')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.personal.data.1')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.personal.data.2.1')}} <a target="_blank" href="https://www.stotinka.hr">
            www.stotinka.hr</a> {{t('privacy.policy.personal.data.2.2')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.personal.data.3')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.personal.data.4')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.personal.data.5')}}
          </p>
          <p>
            {{t('privacy.policy.personal.data.6')}}
          </p>
          <p class="fw-bold pb-3 pt-4">
            {{t('privacy.policy.data.safety')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.data.safety.1.1')}} <a target="_blank" href="https://www.stotinka.hr">
            www.stotinka.hr</a> {{t('privacy.policy.data.safety.1.2')}}
          </p>
          <p>
            {{t('privacy.policy.data.safety.2')}}
          </p>
          <p class="fw-bold pb-3 pt-4">
            {{t('privacy.policy.cookies')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.cookies.1.1')}} <a target="_blank" href="https://www.stotinka.hr">
            www.stotinka.hr</a> {{t('privacy.policy.cookies.1.2')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.cookies.2')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.cookies.3')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.cookies.4')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.cookies.5.1')}} <a target="_blank" href="https://www.stotinka.hr">
            www.stotinka.hr</a> {{t('privacy.policy.cookies.5.2')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.cookies.6')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.cookies.7')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.cookies.8.1')}} <a target="_blank" href="https://www.stotinka.hr">
            www.stotinka.hr</a> {{t('privacy.policy.cookies.8.2')}}
          </p>
          <p>
            {{t('privacy.policy.cookies.9')}}
          </p>
          <p class="fw-bold pb-3 pt-4">
            {{t('privacy.policy.cookie.prevention')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.cookie.prevention.1')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.cookie.prevention.2')}}
            <a target="_blank" href="https://www.allaboutcookies.org">www.allaboutcookies.org</a>.
          </p>
          <p>
            {{t('privacy.policy.cookie.prevention.3')}}
          </p>
          <p class="fw-bold pb-3 pt-4">
            {{t('privacy.policy.conditions')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.conditions.1')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.conditions.2')}}
          </p>
          <p>
            {{t('privacy.policy.conditions.3')}}
          </p>
          <p class="fw-bold pb-3 pt-4">
            {{t('privacy.policy.contact')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.contact.1')}}
          </p>
          <p class="pb-3">
            {{t('privacy.policy.contact.2')}} <a href="mailto:{{contactMail}}">timing&#64;stotinka.hr</a>
          </p>
        </app-form-card>
      </div>
    </div>
  </section>
</app-page-template>
</ng-container>
